<template>
  <div>
    <div class="discover-countries">Showing artists in
      <div class="discover-countries-model" @click="openModal">
        <div class="discover-countries-names">{{ (selected || {}).name }}</div>
      </div>
    </div>

    <div class="location-search">
      <modal name="country-modal" height="auto" :adaptive="true"
        @opened="openMultiselect"
      >
        <multiselect
          ref="multiselect"
          :value="selected"
          @select="onSelected"
          placeholder="Search country"
          :options="countries"
          label="name"
          :internalSearch="true"
          track-by="id"
        >
          <span slot="noResult">Nothing was found</span>
        </multiselect>
        <div></div>
      </modal>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  props: {
    selectedCountry: Object
  },
  components: {
    Multiselect
  },
  data: function () {
    return {
      selected: this.selectedCountry,
      countries: []
    }
  },
  methods: {
    onSelected (option) {
      this.selected = option
      this.$axios({url: `/global_settings/select_country?id=${option.id}`, baseURL: '', method: 'post'})
        .then(response => {
          this.$modal.hide('country-modal')
          localStorage.setItem('location_country', option.slug)
          localStorage.setItem('country_id', option.id)
          localStorage.setItem('country_name', option.name)
          localStorage.setItem('short_form', option.short_form)
          localStorage.setItem('show_city', false)
          window.dispatchEvent( new Event('storage') )
        })
    },
    openModal () {
      if (this.countries.length > 0) {
        this.$modal.show('country-modal')
      } else {
        this.$axios({url: '/global_settings/countries', baseURL: '', method: 'get'})
          .then(response => {
            this.countries = response.data
            this.$modal.show('country-modal')
          })
      }
    },
    openMultiselect () {
      this.$refs.multiselect.activate();
    },
    closeMultiselect () {
      this.$refs.multiselect.deactivate();
    }
  }
}
</script>
